module.exports = __webpack_public_path__ + "static/img/kuwo.538d9bc1.png";